import type { DragEvent } from "react";

/**
 * In-app drags carry this custom MIME type so the page's "drop files to
 * upload" overlay ignores them, and drop targets get the full id list
 * without reading React state.
 */
export const DRIVE_MIME = "application/x-fg-drive-item";

export const isDriveDrag = (e: DragEvent | globalThis.DragEvent): boolean =>
    Boolean(e.dataTransfer?.types.includes(DRIVE_MIME));

export const isFileDrag = (e: DragEvent | globalThis.DragEvent): boolean =>
    Boolean(e.dataTransfer?.types.includes("Files")) && !isDriveDrag(e);

export function setDriveDrag(e: DragEvent, ids: string[], label: string): void {
    e.dataTransfer.setData(DRIVE_MIME, JSON.stringify({ ids }));
    e.dataTransfer.setData("text/plain", label);
    e.dataTransfer.effectAllowed = "move";
}

export function readDriveDrag(e: DragEvent): string[] {
    try {
        const parsed = JSON.parse(e.dataTransfer.getData(DRIVE_MIME)) as { ids?: unknown };
        return Array.isArray(parsed.ids) ? parsed.ids.filter((x): x is string => typeof x === "string") : [];
    } catch {
        return [];
    }
}
